import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'linkType'})
export class LinkTypePipe implements PipeTransform {

  transform(links: Talent.ContactUrl[], type: string | string[]): Talent.ContactUrl[] {
    return links ? links.filter(link => Array.isArray(type) ?
      (type as string[]).indexOf(link.type) !== -1 : link.type === type) : [];
  }
}
